<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{
            $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
          }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.reason'
                )
              }}</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.delete_reason"
                  :class="{ 'is-invalid': errors.has('delete_reason') }"
                  autofocus
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('delete_reason')"
                >
                  {{ errors.first('delete_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="destroy"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['data'],
  name: 'student-profile-delete-form',
  data() {
    return {
      model: {
        student_id: '',
        delete_reason: ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.model.student_id = this.data.student_id
  },
  methods: {
    destroy() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('studentProfile/destroy', this.model)
        .then(response => {
          return this.$store.dispatch('studentProfile/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
